'use strict';

angular.module('ClinicApp').directive('promoNprsRemainingBanner', function(OCUtil) {
  return {
    restrict: 'A',
    templateUrl: '/views/directives/_promo-nprs-remaining-banner.html',
    link: function($scope) {
      return OCUtil.getModelFromURL('clinic').then(function(clinic) {
        $scope.remainingPromoNprs = _.get(clinic, 'remainingPromoNprs', 0);
      });
    },
  };
});
